import "./Sidebar.css";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import CssBaseline from "@mui/material/CssBaseline";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { useEffect, useState } from "react";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import Collapse from "@mui/material/Collapse";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import MapsHomeWorkIcon from "@mui/icons-material/MapsHomeWork";
import GroupIcon from "@mui/icons-material/Group";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import AssessmentIcon from "@mui/icons-material/Assessment";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import DashboardIcon from "@mui/icons-material/Dashboard";
import { useNavigate } from "react-router-dom";
import Credinlogo from "../icons/Credinlogo.svg";
import Credinlogo_1 from "../icons/india-450_128.gif";
import Userplaceholder from "../assets/userplaceholder.png";
import axios from "axios";
import { url } from "../App";
import Cookies from 'js-cookie';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import BookIcon from '@mui/icons-material/Book';

const drawerWidth = {
  xs: 150,
  sm: 160,
  md: "14%",
  lg: "14%",
  xl: "14%",
};

const boxSX = {
  "&:hover": {
    transition: "all 0.3s",
  },
  "&$selected": {
    backgroundColor: "white",
  },
  fontSize: "10px",
};

const collapseBoxSX = {
  backgroundColor: "#034EA2",
};

const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open }) => ({
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${drawerWidth}px`,
    ...(open && {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    }),
  })
);

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  transition: theme.transitions.create(["margin", "width"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: `${drawerWidth}px`,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
}));

export default function Sidebar(props) {
  // console.log(props.dataSend);

  const [showSettings, setShowSettings] = useState(false);

  const handleImageClick = () => {
    setShowSettings(!showSettings);
  };

  const theme = useTheme();
  const [openDrawer, setOpenDrawer] = useState(true);
  const [openLoan, setOpenLoan] = useState(false);
  const [openCollateral, setOpenColleteral] = useState(false);
  const [openCoApplicant, setOpenCoApplicant] = useState(false);
  const [openBorrowers, setOpenBorrowers] = useState(false);
  const [openLeads, setOpenLeads] = useState(false);
  const [visible, setvisible] = useState(false);
  const [AddLeadVisible, setAddLeadVisible] = useState(false);
  const [ViewLeadVisible, setViewLeadVisible] = useState(false);
  const [ViewBorrowerVisible, setViewBorrowerVisible] = useState(false);
  const [ViewLoanVisible, setViewLoanVisible] = useState(false);
  const [CpvCasesVisible, setCpvCasesVisible] = useState(false);
  const [ViewCoapplicantVisible, setViewCoapplicantVisible] = useState(false);
  const [ViewCollateralVisible, setViewCollateralVisible] = useState(false);
  const [ReportsVisible, setReportsVisible] = useState(false);
  const [BulkUploadVisible, setBulkUploadVisible] = useState(false);
  const [BureauVisible, setBureauVisible] = useState(false);

  const token = Cookies.get('Token');
  const email = Cookies.get('Email');

  const Navigate = useNavigate();

  const handleDrawerOpen = () => {
    setOpenDrawer(true);
    props.click(true);
  };

  const handleDrawerClose = () => {
    setOpenDrawer(false);
    props.click(false);
  };
  const handleLoanClick = () => {
    setOpenLoan(!openLoan);
    setOpenColleteral(false);
    setOpenCoApplicant(false);
    setOpenBorrowers(false);
    setOpenLeads(false);
  };
  const handleCollateralClick = () => {
    setOpenColleteral(!openCollateral);
    setOpenCoApplicant(false);
    setOpenBorrowers(false);
    setOpenLeads(false);
    setOpenLoan(false);
  };
  const handleCoApplicantClick = () => {
    setOpenCoApplicant(!openCoApplicant);
    setOpenBorrowers(false);
    setOpenColleteral(false);
    setOpenLeads(false);
    setOpenLoan(false);
  };
  const handleBorrowerClick = () => {
    setOpenBorrowers(!openBorrowers);
    setOpenColleteral(false);
    setOpenCoApplicant(false);
    setOpenLeads(false);
    setOpenLoan(false);
  };
  const handleLeadsClicks = () => {
    setOpenLeads(!openLeads);
    setOpenColleteral(false);
    setOpenCoApplicant(false);
    setOpenBorrowers(false);
    setOpenLoan(false);
  };

  useEffect(() => {
    axios
      .post(url + "/user/check/session/v1", {
        token: token === undefined ? "NA" : token,
        email: email === undefined ? "NA" : email
      })
      .then((res) => {
        Cookies.set('Token', res.data.token, { expires: 1 });
        if (email === "rupesh.bishnoi@credin.in") {
          setvisible(true);
        }
        else {
          axios
            .post(url + "/user/getsingle", {
              token: res.data.token,
              email: email,
              useremail: email
            })
            .then((res) => {
              //  console.log(res);
              setAddLeadVisible(res.data[0].permission.add_lead);
              setViewLeadVisible(res.data[0].permission.view_lead);
              setViewBorrowerVisible(res.data[0].permission.view_borrower);
              setViewLoanVisible(res.data[0].permission.view_loan);
              setCpvCasesVisible(res.data[0].permission.view_cpv_case);
              setViewCoapplicantVisible(res.data[0].permission.view_co_borrower);
              setViewCollateralVisible(res.data[0].permission.view_collateral);
              setReportsVisible(
                res.data[0].permission.borrower_report_types ||
                res.data[0].permission.loan_report_report_types ||
                res.data[0].permission.disbursement_report_report_types ||
                res.data[0].permission.master_report_report_types ||
                res.data[0].permission.resolved_query ||
                res.data[0].permission.raised_query ||
                res.data[0].permission.rfd_report_report_types ||
                res.data[0].permission.coapplicant_report_report_types ||
                res.data[0].permission.loan_application_report_types ||
                res.data[0].permission.loan_dynamic_application_report_types
              
              );
              setBureauVisible(res.data[0].permission.view_bureau);
              setBulkUploadVisible(res.data[0].permission.bulk_upload_borrower || res.data[0].permission.bulk_upload_co_borrower || res.data[0].permission.bulk_upload_collateral || res.data[0].permission.bulk_upload_lead || res.data[0].permission.bulk_upload_loan);
              setvisible(false);
            })
            .catch((err) => {
              console.log(err);
            })
        };

        if (props.dataSend === "AddLead") {
          setOpenLeads(true);
        } if (props.dataSend === "ViewLead") {
          setOpenLeads(true);
        } if (props.dataSend === "ViewBorrower") {
          setOpenBorrowers(true);
        } if (props.dataSend === "AddLoan") {
          setOpenLoan(true);
        } if (props.dataSend === "ViewLoans") {
          setOpenLoan(true);
        } if (props.dataSend === "CpvCases") {
          setOpenLoan(true);
        } if (props.dataSend === "AddCoApplicant") {
          setOpenCoApplicant(true);
        } if (props.dataSend === "ViewCoApplicant") {
          setOpenCoApplicant(true);
        } if (props.dataSend === "AddCollateral") {
          setOpenColleteral(true);
        } if (props.dataSend === "ViewCollateral") {
          setOpenColleteral(true);
        }

      })
      .catch((err) => {
        console.log(err);
      });
    // eslint-disable-next-line
  }, [props.dataSend]);

  const handleLogout = () => {
    let text = "Are you sure you want to Logout?";
    if (window.confirm(text) === true) {
      // console.log("Logged Out");
      localStorage.clear();
      Cookies.remove('Token');
      Cookies.remove('Email');
      Navigate("/");
    }
  };

  const mql = window.matchMedia("(min-width: 1200px)");
  const sql = window.matchMedia("(max-width: 1300px)");

  const listenerFunc = () => {
    handleDrawerClose();
  };

  const listenerFunc1 = () => {
    handleDrawerOpen();
  };

  mql.addEventListener("change", (e) => listenerFunc());
  sql.addEventListener("change", (e) => listenerFunc1());


  return (
    <Box sx={{ backgroundColor: "#EDF5FF" }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        open={openDrawer}
        sx={{ backgroundColor: "white", color: "grey" }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{ mr: 2, ...(openDrawer && { display: "none" }) }}
          >
            <MenuIcon />
          </IconButton>
          <div className="toolbar-div">
            <span style={{ color: "black" }}>
              {Cookies.get('Email')}
            </span>
            <button className="navbar-drawer-btn">
              <img
                src={Userplaceholder}
                className="user-image"
                alt=""
                onClick={handleImageClick}
              />
            </button>
            <div className={`settings ${showSettings ? "show" : ""}`}>
              {/* <button
                className="navbar-dd"
                onClick={() => Navigate("/changepassword")}
              >
                Change Password
              </button> */}
              <button className="navbar-dd" onClick={handleLogout}>
                Logout
              </button>
            </div>
          </div>
        </Toolbar>
      </AppBar>
      <Drawer
        sx={{
          "&::-webkit-scrollbar": {
            width: 20,
          },
          "&::-webkit-scrollbar-track": {
            backgroundColor: "red",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "red",
          },
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
            backgroundColor: "#ebedef",
            color: "black",
            transition: "2s",
          },
          transition: "all 2s",
        }}
        variant="persistent"
        anchor="left"
        open={openDrawer}
      >
        <DrawerHeader sx={{ backgroundColor: "white" }}>
          <img src={Credinlogo} alt="" style={{ height: 40, width: 150 }} />
          <img src={Credinlogo_1} alt="" style={{ height: 30, width: 50 }} />
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === "ltr" ? (
              <ChevronLeftIcon />
            ) : (
              <ChevronRightIcon />
            )}
          </IconButton>
        </DrawerHeader>
        <Divider />
        <List
          sx={{
            fontSize: "1px",
            "&::-webkit-scrollbar": {
              width: 20,
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: "red",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "red",
            },
          }}
        >
          <Box>
            <ListItem
              disablePadding
              onClick={() => Navigate("/home")}
              sx={{
                backgroundColor:
                  props.dataSend === "dashboard" ? "#0265d4" : "",
              }}
            >
              <ListItemButton>
                <ListItemIcon>
                  <DashboardIcon
                    sx={{
                      color: "#034ea2",
                      fontSize: "30px"
                    }}
                  />
                </ListItemIcon>
                <ListItemText
                  primary="Dashboard"
                  sx={{
                    color: props.dataSend === "dashboard" ? "white" : "",
                  }}
                />
              </ListItemButton>
            </ListItem>
          </Box>

          {(AddLeadVisible || ViewLeadVisible || visible) && (
            <Box sx={boxSX}>
              <ListItem disablePadding>
                <ListItemButton onClick={handleLeadsClicks}>
                  <ListItemIcon>
                    <AccountBoxIcon sx={{ color: "#034ea2", fontSize: "30px" }} />
                  </ListItemIcon>
                  <ListItemText primary="Leads" />
                  {openLeads ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
              </ListItem>
            </Box>
          )}

          <Box sx={collapseBoxSX}>
            {(AddLeadVisible || visible) && (
              <Collapse in={openLeads} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <Box
                    sx={{
                      backgroundColor:
                        props.dataSend === "AddLead" ? "#0265d4" : "#034ea2",
                    }}
                  >
                    <ListItemButton
                      sx={{ pl: 4 }}
                      onClick={() => Navigate("/lead/add")}
                    >
                      <ListItemIcon></ListItemIcon>
                      <ListItemText sx={{ color: "white" }} primary="Add Lead" />
                    </ListItemButton>
                  </Box>
                </List>
              </Collapse>
            )}

            {(ViewLeadVisible || visible) && (
              <Collapse in={openLeads} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <Box
                    sx={{
                      backgroundColor:
                        props.dataSend === "ViewLead" ? "#0265d4" : "#034ea2",
                    }}
                  >
                    <ListItemButton
                      sx={{ pl: 4 }}
                      onClick={() => Navigate("/lead/view")}
                    >
                      <ListItemIcon></ListItemIcon>
                      <ListItemText sx={{ color: "white" }} primary="View Lead" />
                    </ListItemButton>
                  </Box>
                </List>
              </Collapse>
            )}
          </Box>

          {(BureauVisible || visible) && (
            <Box>
              <ListItem
                disablePadding
                onClick={() => Navigate("/bureau")}
                sx={{
                  backgroundColor: props.dataSend === "Bureau" ? "#0265d4" : "",
                }}
              >
                <ListItemButton>
                  <ListItemIcon>
                    <GroupAddIcon
                      sx={{
                        color: "#034ea2",
                        fontSize: "30px"
                      }}
                    />
                  </ListItemIcon>
                  <ListItemText
                    primary="Bureau"
                    sx={{
                      color: props.dataSend === "Bureau" ? "white" : "",
                    }}
                  />
                </ListItemButton>
              </ListItem>
            </Box>
          )}

          {(ViewBorrowerVisible || visible) && (
            <Box sx={boxSX}>
              <ListItem disablePadding>
                <ListItemButton onClick={handleBorrowerClick}>
                  <ListItemIcon>
                    <VerifiedUserIcon
                      sx={{ color: "#034ea2", fontSize: "30px" }}
                    />
                  </ListItemIcon>
                  <ListItemText primary="Borrower" />
                  {openBorrowers ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
              </ListItem>
            </Box>
          )}

          <Box sx={collapseBoxSX}>

            <Collapse in={openBorrowers} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {/* <Box sx={boxSX}>
                  <ListItemButton
                    sx={{ pl: 4 }}
                    onClick={() => Navigate("/borrower/add")}
                  >
                    <ListItemIcon></ListItemIcon>
                    <ListItemText primary="Add Borrower" />
                  </ListItemButton>
                </Box> */}
              </List>
            </Collapse>

            {(ViewBorrowerVisible || visible) && (
              <Collapse in={openBorrowers} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <Box
                    sx={{
                      backgroundColor:
                        props.dataSend === "ViewBorrower" ? "#0265d4" : "#034ea2",
                    }}
                  >
                    <ListItemButton
                      sx={{ pl: 4 }}
                      onClick={() => Navigate("/borrower/view")}
                    >
                      <ListItemIcon></ListItemIcon>
                      <ListItemText
                        sx={{ color: "white" }}
                        primary="View Borrowers"
                      />
                    </ListItemButton>
                  </Box>
                </List>
              </Collapse>
            )}
          </Box>

          {(ViewLoanVisible || CpvCasesVisible || visible) && (
            <Box sx={boxSX}>
              <ListItem disablePadding sx={{ fontSize: "100rem" }}>
                <ListItemButton onClick={handleLoanClick}>
                  <ListItemIcon>
                    <CurrencyRupeeIcon sx={{ color: "#034ea2", fontSize: "30px" }} />
                  </ListItemIcon>
                  <ListItemText primary="Loan" sx={{ fontSize: "10px" }} />
                  {openLoan ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
              </ListItem>
            </Box>
          )}

          <Box sx={collapseBoxSX}>
            {(ViewLoanVisible || visible) && (
              <Collapse in={openLoan} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <Box
                    sx={{
                      backgroundColor:
                        props.dataSend === "ViewLoans" ? "#0265d4" : "#034ea2",
                    }}
                  >
                    <ListItemButton
                      sx={{ pl: 4 }}
                      onClick={() => Navigate("/loan/created")}
                    >
                      <ListItemIcon></ListItemIcon>
                      <ListItemText
                        sx={{ color: "white" }}
                        primary="View Loans"
                      />
                    </ListItemButton>
                  </Box>
                </List>
              </Collapse>
            )}
          </Box>

          <Box sx={collapseBoxSX}>
            {(CpvCasesVisible || visible) && (
              <Collapse in={openLoan} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <Box
                    sx={{
                      backgroundColor:
                        props.dataSend === "CpvCases" ? "#0265d4" : "#034ea2",
                    }}
                  >
                    <ListItemButton
                      sx={{ pl: 4 }}
                      onClick={() => Navigate("/loan/CpvCases")}
                    >
                      <ListItemIcon></ListItemIcon>
                      <ListItemText
                        sx={{ color: "white" }}
                        primary="CPV Cases"
                      />
                    </ListItemButton>
                  </Box>
                </List>
              </Collapse>
            )}
          </Box>

          {(ViewCoapplicantVisible || visible) && (
            <Box sx={boxSX}>
              <ListItem disablePadding sx={{ fontSize: "50px" }}>
                <ListItemButton onClick={handleCoApplicantClick}>
                  <ListItemIcon>
                    <GroupIcon sx={{ color: "#034ea2", fontSize: "30px" }} />
                  </ListItemIcon>
                  <ListItemText
                    primary="Co-applicant"
                    sx={{ fontSize: "50px" }}
                  />
                  {openCoApplicant ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
              </ListItem>
            </Box>
          )}

          <Box sx={collapseBoxSX}>
            {(ViewCoapplicantVisible || visible) && (
              <Collapse in={openCoApplicant} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <Box
                    sx={{
                      backgroundColor:
                        props.dataSend === "ViewCoApplicant"
                          ? "#0265d4"
                          : "#034ea2",
                    }}
                  >
                    <ListItemButton
                      sx={{ pl: 4 }}
                      onClick={() => Navigate("/coapplicant/view")}
                    >
                      <ListItemIcon></ListItemIcon>
                      <ListItemText
                        sx={{ color: "white" }}
                        primary="View Co-applicant"
                      />
                    </ListItemButton>
                  </Box>
                </List>
              </Collapse>
            )}
          </Box>

          {(ViewCollateralVisible || visible) && (
            <Box sx={boxSX}>
              <ListItem disablePadding>
                <ListItemButton onClick={handleCollateralClick}>
                  <ListItemIcon>
                    <MapsHomeWorkIcon
                      sx={{ color: "#034ea2", fontSize: "30px" }}
                    />
                  </ListItemIcon>
                  <ListItemText primary="Collateral" sx={{ fontSize: "10px" }} />
                  {openCollateral ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
              </ListItem>
            </Box>
          )}

          <Box sx={collapseBoxSX}>
            <Collapse in={openCollateral} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
              </List>
            </Collapse>
            {(ViewCollateralVisible || visible) && (
              <Collapse in={openCollateral} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <Box
                    sx={{
                      backgroundColor:
                        props.dataSend === "ViewCollateral"
                          ? "#0265d4"
                          : "#034ea2",
                    }}
                  >
                    <ListItemButton
                      sx={{ pl: 4 }}
                      onClick={() => Navigate("/collateral/view")}
                    >
                      <ListItemIcon></ListItemIcon>
                      <ListItemText
                        sx={{ color: "white" }}
                        primary="View Collateral"
                      />
                    </ListItemButton>
                  </Box>
                </List>
              </Collapse>
            )}
          </Box>

          {(ReportsVisible || visible) && (
            <Box>
              <ListItem
                disablePadding
                onClick={() => Navigate("/reports")}
                sx={{
                  backgroundColor: props.dataSend === "Reports" ? "#0265d4" : "",
                }}
              >
                <ListItemButton>
                  <ListItemIcon>
                    <AssessmentIcon
                      sx={{
                        color: "#034ea2",
                        fontSize: "30px"
                      }}
                    />
                  </ListItemIcon>
                  <ListItemText
                    primary="Reports"
                    sx={{
                      color: props.dataSend === "Reports" ? "white" : "",
                    }}
                  />
                </ListItemButton>
              </ListItem>
            </Box>
          )}

          {(BulkUploadVisible || visible) && (
            <Box>
              <ListItem
                disablePadding
                onClick={() => Navigate("/bulkUpload")}
                sx={{
                  backgroundColor:
                    props.dataSend === "BulkUpload" ? "#0265d4" : "",
                }}
              >
                <ListItemButton>
                  <ListItemIcon>
                    <UploadFileIcon
                      sx={{
                        color: "#034ea2",
                        fontSize: "30px",
                      }}
                    />
                  </ListItemIcon>
                  <ListItemText
                    primary="Bulk Upload"
                    sx={{
                      color: props.dataSend === "BulkUpload" ? "white" : "",
                    }}
                  />
                </ListItemButton>
              </ListItem>
            </Box>
          )}
          {email === "rupesh.bishnoi@credin.in" || email === "ayushi.joshi@credin.in" ? <Box>
            <ListItem
              disablePadding
              onClick={() => Navigate("/logs")}
              sx={{
                backgroundColor:
                  props.dataSend === "Logs" ? "#0265d4" : "",
              }}
            >
              <ListItemButton>
                <ListItemIcon>
                  <BookIcon
                    sx={{
                      color: "#034ea2",
                      fontSize: "30px",
                    }}
                  />
                </ListItemIcon>
                <ListItemText
                  primary="Logs"
                  sx={{
                    color: props.dataSend === "Logs" ? "white" : "",
                  }}
                />
              </ListItemButton>
            </ListItem>
          </Box> : null}
        </List>
      </Drawer>
      <Main>{props.children}</Main>
    </Box>
  );
}
